import { __require as requireIsCallable } from './node_modules-core-js-internals-is-callable.js';

var isObject;
var hasRequiredIsObject;

function requireIsObject () {
	if (hasRequiredIsObject) return isObject;
	hasRequiredIsObject = 1;
	var isCallable = requireIsCallable();

	isObject = function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};
	return isObject;
}

export { requireIsObject as __require };
//# sourceMappingURL=node_modules-core-js-internals-is-object.js.map
